import { GridApi, IRowNode } from 'ag-grid-community'

export const getAllVisibleNodes = (api: GridApi): IRowNode[] => {
  const nodes: IRowNode[] = []
  api.forEachNodeAfterFilter(n => {
    nodes.push(n)
  })
  return nodes
}
